import TweenMax from './tweenmax';
/* set jquery globals */
const $ = window.jQuery;
const jQuery = window.jQuery;

$(function() {
	// Animationn Variables
var $svgWrap = $('.price-advisor-svg-wrap');
var $svg = $('#price-advisor-svg');
var $circle_wrap = $('#circle-wrap');

var $circle_red = $('#circle-red');
var $circle_red_intro = $('#circle-red-intro');
var $circle_red_bullets = $('#circle-red-bullets');

var $circle_green = $('#circle-green');
var $circle_green_intro = $('#circle-green-intro');
var $circle_green_bullets = $('#circle-green-bullets');

var $circle_white = $('#circle-white');
var $circle_white_intro = $('#circle-white-intro');
var $circle_white_bullets = $('#circle-white-bullets');

var $kbb_logo = $('#kbb-logo');

var $arrow_1 = $('.arrow-1')
var $arrow_2 = $('.arrow-2')

// Presets
TweenMax.set($circle_wrap, {
	transformOrigin: 'right bottom'
})
TweenMax.set([$circle_red_intro, $circle_red_bullets, $circle_green_intro, $circle_green_bullets, $circle_white_intro, $circle_white_bullets], {
	opacity: '0',
	transformOrigin: 'center center'
})
TweenMax.set([$circle_red_intro, $circle_green_intro, $circle_white_intro], {
	yPercent: '-100%'
})
TweenMax.set([$circle_red_bullets, $circle_green_bullets, $circle_white_bullets], {
	xPercent: '-100%'
})

TweenMax.set($kbb_logo, {
	transformOrigin: 'center bottom',
	ease:Back.easeOut,
})
TweenMax.set([$circle_red, $circle_white], {
	transformOrigin: 'center bottom'
})
TweenMax.set($circle_green, {
	transformOrigin: 'center bottom'
})

TweenMax.set($arrow_1, {
	x: 3
})
TweenMax.set($arrow_2, {
	x: -4
})


// Red Animation
var tl_red = new TimelineMax({
	paused: true
})

tl_red.to($circle_red, .75, {
	scale: '2',
})
.to([$circle_green, $circle_white], 0, {
	css: {pointerEvents: 'none'}
})
.to($circle_wrap, .75, {
	scale: '1.4',
	transformOrigin: 'right bottom',
}, "-=.75")
.to($kbb_logo, .75, {
	opacity: '.5',
	yPercent: '30',
	scale: '.8'
}, "-=.75")
.to($circle_green, .75, {
	opacity: '.5'
}, "-=.75")
.to($circle_white, .75, {
	opacity: '.5'
}, "-=.75")
.to($circle_red_intro, .5, {
	opacity: '1',
	yPercent: '0',
	ease:Back.easeOut
})
.to($circle_red_bullets, .5, {
	opacity: '1',
	xPercent: '0',
	ease:Back.easeOut
})

$circle_red.click(function() {
	if (!$svgWrap.hasClass('push')) {
		tl_red.play();
		$circle_wrap.append($circle_red);
		$svgWrap.addClass('push').addClass('push-2');
		
		setTimeout(function() {
			$svgWrap.addClass('reset-red');
		}, 1000);
	}
});

$('body').on('click', '.reset-red', function() {
	tl_red.reverse().timeScale(2);
	$svgWrap.removeClass('reset-red').removeClass('push').removeClass('push-2');
})

// Green animation
var tl_green = new TimelineMax({
	paused: true
})

tl_green.to($circle_wrap, .75, {
	scale: '1.4',
	transformOrigin: '61% bottom',
})
.to($circle_green, .75, {
	scale: '1.5',
	transformOrigin: '66% bottom'
}, "-=.75")
.to([$circle_red, $circle_white], 0, {
	css: {pointerEvents: 'none'}
})
.to($kbb_logo, .75, {
	opacity: '.5',
	yPercent: '30',
	scale: '.8'
}, "-=.75")
.to($circle_red, .75, {
	opacity: '.5'
}, "-=.75")
.to($circle_white, .75, {
	opacity: '.5'
}, "-=.75")
.to($circle_green_intro, .5, {
	opacity: '1',
	yPercent: '0',
	ease:Back.easeOut
})
.to($circle_green_bullets, .5, {
	opacity: '1',
	xPercent: '0',
	ease:Back.easeOut
})

$circle_green.click(function() {
	if (!$svgWrap.hasClass('push')) {
		tl_green.play();
		$circle_wrap.append($circle_green);
		$svgWrap.addClass('push');
		
		setTimeout(function() {
			$svgWrap.addClass('reset-green');
		}, 1000);
	}
});

$('body').on('click', '.reset-green', function() {
	tl_green.reverse().timeScale(2);
	$svgWrap.removeClass('reset-green').removeClass('push');
})

// White Animation
var tl_white = new TimelineMax({
	paused: true
})

tl_white.to($circle_white, .75, {
	scale: '1.8',
})
.to([$circle_green, $circle_red], 0, {
	css: {pointerEvents: 'none'}
})
.to($circle_wrap, .75, {
	scale: '1.4',
	transformOrigin: 'center bottom',
}, "-=.75")
.to($kbb_logo, .75, {
	opacity: '.5',
	yPercent: '30',
	scale: '.8'
}, "-=.75")
.to($circle_red, .75, {
	opacity: '.5'
}, "-=.75")
.to($circle_green, .75, {
	opacity: '.5'
}, "-=.75")
.to($circle_white_intro, .5, {
	opacity: '1',
	yPercent: '0',
	ease:Back.easeOut
})
.to($circle_white_bullets, .5, {
	opacity: '1',
	xPercent: '0',
	ease:Back.easeOut
})

$circle_white.click(function() {
	if (!$svgWrap.hasClass('push')) {
		tl_white.play();
		$circle_wrap.append($circle_white);
		$svgWrap.addClass('push').addClass('push-2');
		
		setTimeout(function() {
			$svgWrap.addClass('reset-white');
		}, 1000);
	}
});

$('body').on('click', '.reset-white', function() {
	tl_white.reverse().timeScale(2);
	$svgWrap.removeClass('reset-white').removeClass('push').removeClass('push-2');
})
})
